import { Phone, MapPin } from "lucide-react";
import { scrollToSection } from "@/lib/scrollToSection";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_koko-showcase/artifacts/qadunrd3_1000069989-removebg-preview%20%281%29.png";

export default function Footer() {
  const scrollTo = (href) => scrollToSection(href);

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img src={LOGO_URL} alt="KoKo Sites - Affordable Web Design Studio in Bolpur Santiniketan, India" className="h-14 w-auto mb-6" />
            <p className="text-zinc-400 text-sm leading-relaxed">
              Independent web design studio crafting stunning digital experiences for businesses across India. Founded by Kamran Zahin Aziz in Bolpur Santiniketan, West Bengal. Serving Mumbai, Delhi, Bangalore, Chennai, Hyderabad, Pune, Kolkata and more.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-[0.2em] text-white mb-6">Quick Links</h4>
            <div className="space-y-3">
              {["About", "Services", "Pricing", "App", "Contact"].map((item) => (
                <div key={item}>
                  <button
                    onClick={() => scrollTo(`#${item.toLowerCase()}`)}
                    className="link-underline text-sm text-zinc-400 hover:text-red-500 transition-colors"
                  >
                    {item}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-[0.2em] text-white mb-6">Services</h4>
            <div className="space-y-3">
              {["Custom Web Design", "E-Commerce Sites", "SEO Optimization", "Website Maintenance", "UI/UX Design"].map((s) => (
                <div key={s}>
                  <button
                    onClick={() => scrollTo("#services")}
                    className="link-underline text-sm text-zinc-400 hover:text-red-500 transition-colors cursor-pointer text-left"
                  >
                    {s}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-[0.2em] text-white mb-6">Contact</h4>
            <div className="space-y-4">
              <a href="tel:+919242478118" className="flex items-center gap-3 text-sm text-zinc-400 hover:text-red-500 transition-colors">
                <Phone size={16} className="text-red-600 shrink-0" />
                +91 92424 78118
              </a>
              <a href="https://maps.google.com/?q=Bolpur+Santiniketan+Birbhum+West+Bengal+731235" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-sm text-zinc-400 hover:text-red-500 transition-colors cursor-pointer">
                <MapPin size={16} className="text-red-600 shrink-0 mt-0.5" />
                Bolpur Santiniketan, Birbhum,<br />West Bengal 731235, India
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">
            &copy; {new Date().getFullYear()} KoKo Sites. All rights reserved. Designed by Kamran Zahin Aziz.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://wa.me/919242478118" target="_blank" rel="noopener noreferrer" className="text-xs text-zinc-500 hover:text-red-500 transition-colors uppercase tracking-wider">
              WhatsApp
            </a>
            <span className="text-zinc-700">|</span>
            <span className="text-xs text-zinc-500 uppercase tracking-wider">Made in India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
